export enum DataserverApiRoute {
    Auth = 'auth',
    Utility = 'utility',
    Printing = 'printing',
    Motionmaster = 'motionmaster',
    StorageBackup = 'storage-backup',
}
